<template>
  <div>
    <el-dialog title="Completed courses" :visible.sync="dialogVisible" @close="closeDialog()">
      <el-table :data="courses.data">
        <el-table-column property="course.course_title" label="Course Name" width="300"></el-table-column>
        <el-table-column property="end_time" label="Date of Completion">
          <template slot-scope="scope">
            <span>{{ scope.row.end_time | formattedDate }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="courses.total > courses.per_page"
                     background
                     layout="prev, pager, next"
                     @current-change="getCourses"
                     :page-size="courses.per_page"
                     :pager-count="5"
                     :total="courses.total"
                     :current-page="courses.current_page"
                     class="float-right"
      >
      </el-pagination>
      <br>
    </el-dialog>
  </div>
</template>

<script>
import {LearningReportApi} from '@/services/api'

export default {
  name: 'CompletedCoursesModal',
  data: () => ({
    dialogVisible: false,
    courses: {},
    userId: '',
  }),
  computed: {
    //
  },
  mounted() {
    this.$parent.$on('completed-courses', this.handleParentEvent)
  },
  methods: {
    async handleParentEvent(userId) {
      this.userId = userId
      await this.getCourses(1)
      this.dialogVisible = true
    },
    getCourses(page = 1) {
      this.is_loading = true
      let q = JSON.parse(JSON.stringify(this.$route.query))
      let params = {...{type: 'completed', page: page}, ...q}

      LearningReportApi.studentInProgressCourses(this.userId, params).then(courses => {
        this.courses = courses
      }).catch(error => {
        console.log('error: ', error)
      }).finally(() => {
        this.is_loading = false
      })
    },
    closeDialog() {
      this.courses = {}
    }
  },
  filters: {
    formattedDate: function (value) {
      return moment(value).format('Do MMMM YYYY')
    }
  }
}
</script>
